import { useState } from 'react';

import { useGoogleMapsScript } from '@spotahome/marketplace-common/src/utils/google-maps-script.google';

import InteractiveMap from './InteractiveMap.google';

const InteractiveMapContainer = props => {
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  useGoogleMapsScript(() => setIsMapLoaded(true));

  return isMapLoaded ? <InteractiveMap {...props} /> : null;
};

export default InteractiveMapContainer;
